import { ShippingType } from './hooks/useShippingType';

export const excludeShippingPromos = (shippingType: ShippingType): boolean => {
    return shippingType === 'free' || shippingType === 'free_discounted';
};
